import { CommissionStructureFormPage, type CommissionFormConfig } from '@/pages/CommissionStructures/Form'
import { PartnerCommissionStructuresService } from '@/services/modules/CommissionStructuresService'

/** Form de modelo de comissão do parceiro (reusa o form do admin, escopado a ele). */
const PARTNER_FORM_CFG: CommissionFormConfig = {
  service: PartnerCommissionStructuresService,
  subtitle: 'Modelo de comissão da sua rede',
  listPath: '/partner/commission-models',
  crumbs: (edit) => [
    { label: 'Comercial' },
    { label: 'Modelos de comissão', to: '/partner/commission-models' },
    { label: edit ? 'Editar' : 'Novo' },
  ],
}

export function PartnerCommissionModelFormPage() {
  return <CommissionStructureFormPage cfg={PARTNER_FORM_CFG} />
}

export default PartnerCommissionModelFormPage
